import React from 'react'
import {Svg} from '@modifi/ui'

export default ({...props}) => (
  <Svg viewBox="0 0 150 150" {...props}>
    <g fill="none" fillRule="evenodd" transform="translate(26 29)">
      <path
        d="m36 0h58v37.7054264h-10.9414062v9.2945736l-14.7122396-9.2945736h-32.3463542z"
        stroke="#51565c"
        strokeWidth="3.5"
      />
      <path
        d="m0 44h58v37.7054264h-31.6080729l-14.7122396 9.2945736v-9.2945736h-11.6796875z"
        stroke="#51565c"
        strokeWidth="3.5"
      />
      <path d="m9 58h10v10h-10z" fill="#15539f" />
      <path d="m47 14h10v10h-10z" fill="#15539f" />
      <path d="m23 58h10v10h-10z" fill="#53a2d9" />
      <path d="m61 14h10v10h-10z" fill="#53a2d9" />
      <g fill="#7bb835">
        <path d="m37 58h10v10h-10z" />
        <path d="m74 14h10v10h-10z" />
      </g>
    </g>
  </Svg>
)
